var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center-cross"},[_c('sub-button',{attrs:{"size":"m","hollow":""},on:{"click":_vm.selectProduct}},[_vm._v("选择商品")]),_c('span',{staticStyle:{"margin-left":"10px","font-size":"13px","color":"#666"}},[_vm._v("已选"+_vm._s(_vm.dataValue.length)+"件")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }